// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__2HfpA","widePaddingOnDesktop":"Container_widePaddingOnDesktop__2-DII"};